import { useEffect } from "react";
import AppLayout from "../layouts/AppLayout.jsx";
import CanvaCard from "../components/CanvaCard.jsx";
import { useCanva } from "../context/CanvaContext.jsx";
import { useAuth } from "../context/AuthContext.jsx";
import API from "../config/api.js";
import NavMyMedia from "../components/NavMyMedia.jsx";

export default function MyCanva() {
  const { user } = useAuth();
  const {
    connected,
    canvaUsername,
    designs,
    loading,
    hasMore,
    loadMore,
    fetchDesigns,
    jobsRunning,
    initCanva,
  } = useCanva();

  // sync canva connection status from user object
  useEffect(() => {
    if (user) initCanva(user);
  }, [user, initCanva]);

  // load designs on mount when connected
  useEffect(() => {
    if (connected && designs.length === 0) {
      fetchDesigns("", true);
    }
  }, [connected]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <AppLayout currentPage="my-canva">
          <NavMyMedia currentPage="my-canva" />

      <div className="mt-4">

        {/* Not connected */}
        {!connected && (
          <div className="bg-secondary-light p-5 rounded-4">
            <h1 className="fs-6">Easily Import Your Canva Designs</h1>
            <p>Bring your ideas to life! Instantly add your Canva creations as images or reels to your media library.</p>
            <a
              href={`${API.canva}?getAuthorization=true`}
              className="btn btn-white shadow"
            >
              <img src="/assets/img/canva-icon.webp" className="rounded-circle me-2" width="30" alt="Canva" />
              Connect With Canva
            </a>
          </div>
        )}

        {/* Connected */}
        {connected && (
          <>
            {/* Header */}
            <div className="row g-4 justify-content-between align-items-center mb-3">
              <div className="col-md-6 d-flex align-items-center gap-2">
                <h6 className="mb-0">Canva Designs</h6>

                {jobsRunning && (
                  <span className="badge bg-warning text-dark d-flex align-items-center gap-1" id="canva-status">
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                    Importing…
                  </span>
                )}
              </div>

              <div className="col-md-6 text-center text-md-end">
                <span className="d-inline-block me-3">
                  <img src="/assets/img/canva-icon.webp" className="rounded-circle me-2" width="30" alt="Canva" />
                  {canvaUsername}
                </span>
                <a
                  href={`${API.canva}?removeAuthorization=true`}
                  className="btn btn-outline-primary"
                >
                  <i className="fi fi-rr-link-slash-alt text-danger me-2" />
                  Disconnect <span className="d-none d-md-inline-block">from Canva</span>
                </a>
              </div>
            </div>

            {/* Grid */}
            <div className="row g-2" id="canva-designs-list">
              {designs.map((design) => (
                <div key={design.id} className="col-6 col-md-3 col-xl-2">
                  <CanvaCard design={design} />
                </div>
              ))}
            </div>

            {/* Empty state */}
            {!loading && designs.length === 0 && (
              <div className="card border-0 rounded-4 bg-light mt-3">
                <div className="card-body p-4 text-center">
                  <h6 className="mb-1">No designs found</h6>
                  <p className="mb-0 text-muted">Your Canva designs will appear here.</p>
                </div>
              </div>
            )}

            {/* Load more */}
            {hasMore && (
              <div className="text-center mt-4">
                <button
                  type="button"
                  className="btn btn-primary canva-load-more"
                  onClick={loadMore}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                      Loading…
                    </>
                  ) : (
                    "Load More Designs"
                  )}
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </AppLayout>
  );
}